const useDeleteSubtitle = () => {

    const actionDeleteVideoVTTFile = async (eventId, languages) => {
        try {
            const languagesParam = languages.join(',');
            const response = await fetch(`${process.env.REACT_APP_LATAAMO_PROXY_SERVER}/api/videoTextTrack/${encodeURIComponent(eventId)}/${languagesParam}`, {
                method: 'DELETE'
            });
            if (!response.ok) {
                throw new Error(`Unexpected status code ${response.status}`);
            }
        } catch (error) {
            console.error(error.message);
            throw new Error('error_delete_vtt_file', {
                cause: error
            });
        }
    };

    const deleteSubtitle = async (input) => {
        if (input.deleteSubtitle && input.languages?.length) {
            await actionDeleteVideoVTTFile(input.eventId, input.languages);
        }
    };


    return [deleteSubtitle];
};

export default useDeleteSubtitle;
